import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle, CheckCircle2, Gauge, HelpCircle, ShieldAlert } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/finance`;

const fxof = (v) => `${Math.round(Number(v || 0)).toLocaleString('fr-FR')} F`;

const TONES = {
  ok: { box: 'border-emerald-200 bg-emerald-50 text-emerald-900', bar: 'bg-emerald-500', icon: CheckCircle2 },
  warning: { box: 'border-amber-200 bg-amber-50 text-amber-900', bar: 'bg-amber-500', icon: AlertTriangle },
  critical: { box: 'border-orange-300 bg-orange-50 text-orange-900', bar: 'bg-orange-500', icon: ShieldAlert },
  exceeded: { box: 'border-rose-300 bg-rose-50 text-rose-900', bar: 'bg-rose-600', icon: ShieldAlert },
  unknown: { box: 'border-gray-200 bg-gray-50 text-gray-600', bar: 'bg-gray-400', icon: HelpCircle },
};

/** Cockpit CFO — surveillance du plafond de chiffre d'affaires du régime d'imposition. */
export const RegimeThresholdBanner = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/cockpit/regime-threshold`)
      .then(({ data: res }) => setData(res))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;
  const tone = TONES[data.status] || TONES.unknown;
  const Icon = tone.icon;
  const pct = Math.min(Number(data.usagePct || 0), 100);

  return (
    <div className={`rounded-xl border px-4 py-3 ${tone.box}`} data-testid="regime-threshold-banner">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-2.5">
          <Icon className="mt-0.5 h-4 w-4 shrink-0" />
          <div className="min-w-0">
            <p className="text-sm font-semibold">
              Régime fiscal {data.regime || 'non renseigné'}
              {data.usagePct !== null && data.usagePct !== undefined && (
                <span className="ml-2 text-xs font-normal opacity-80" data-testid="regime-threshold-pct">
                  {data.usagePct} % du plafond
                </span>
              )}
            </p>
            <p className="mt-0.5 text-xs opacity-90">{data.message}</p>
          </div>
        </div>
        {data.ceiling && (
          <div className="shrink-0 text-right text-[11px] opacity-90">
            <div className="flex items-center justify-end gap-1 font-medium">
              <Gauge className="h-3.5 w-3.5" /> {fxof(data.referenceTTC)} / {fxof(data.ceiling)}
            </div>
            {data.headroom !== null && data.headroom > 0 && (
              <div className="mt-0.5">Marge restante : {fxof(data.headroom)}</div>
            )}
            {data.nextRegime && <div className="mt-0.5">Régime suivant : {data.nextRegime}</div>}
          </div>
        )}
      </div>
      {data.ceiling && (
        <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-white/70">
          <div className={`h-full rounded-full transition-all ${tone.bar}`} style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
};

export default RegimeThresholdBanner;
